import axios from "axios";

// Determine the base URL dynamically
const getBaseURL = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Fallback to localhost if no environment variable is set
  const currentHost = window.location.hostname;
  return currentHost === "localhost"
    ? "http://localhost:5000/api"
    : `${window.location.origin}/api`;
};

const axiosInstance = axios.create({
  baseURL: getBaseURL(),
  timeout: 15000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Get the token from localStorage
    const token = localStorage.getItem("token");

    // If token exists, add it to the headers
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    console.error("Frontend Request Error:", error);
    return Promise.reject(error);
  }
);

// Response Interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // Handle token expiration and refresh logic here
    if (error.response && error.response.status === 401) {
      // Token might be expired, attempt to refresh
      const refreshToken = localStorage.getItem("refreshToken");
      if (refreshToken) {
        try {
          const response = await axios.post(`${getBaseURL()}/auth/refresh-token`, { refreshToken });
          const newToken = response.data.token;

          // Save the new token
          localStorage.setItem("token", newToken);

          // Update the original request with the new token
          error.config.headers["Authorization"] = `Bearer ${newToken}`;

          // Retry the original request
          return axios(error.config);
        } catch (refreshError) {
          // Handle refresh token failure (e.g., redirect to login)
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
          window.location.href = "/login"; // Redirect to login
        }
      }
    }

    return Promise.reject(error);
  }
)

export default axiosInstance;

// corrrect with 110
